import React from "react";
import { useQuery } from "@tanstack/react-query";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { ExamDetails, courseExamsApi } from "api/course-exams";
import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { QUERIES_KEYS } from "queries";

interface CourseExamsProps {
  courseId: number;
}
export const CourseExams = ({ courseId }: CourseExamsProps) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_EXAM_FETCH_WITH_STUDENTS(courseId),
    queryFn: () => courseExamsApi.fetchWithStudents(courseId),
  });

  const navigate = useNavigate();
  const cols: TanTableColumn<ExamDetails>[] = [
    {
      id: "name",
      accessorKey: "name",
      header: "Nazwa",
      enableColumnFilter: false,
      // cell: (info) => (
      //   <a target="_blank" href={routes.STUDENT(info.row.original.id)} className="hover:underline">
      //     {info.getValue<string>()}
      //   </a>
      // ),
    },
    {
      id: "courseExamId",
      accessorKey: "courseExamId",
      header: "Akcja",
      enableColumnFilter: false,
      cell: (info) => {
        return (
          <span
            onClick={() => navigate(routes.COURSES_MANAGE_NESTED.EXAMS(courseId, info.getValue<number>()))}
            className="cursor-pointer"
          >
            Wyniki
          </span>
        );
      },
    },
  ];

  const columns = React.useMemo<TanTableColumn<ExamDetails>[]>(() => cols, []);
  if (!data?.data.exams) return null;

  return (
    <>
      <TanTableClient data={data.data.exams} columns={columns} hideBorder />
    </>
  );
};
